// import axios from "axios";
import { formatReminders } from "../helpers";
import { api, authorizationKey, BASE_URL } from "./BASE_URL";

export const fetchReminders = async () => {
  try {
    const response = await api.get(`${BASE_URL}/admin/reminders`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    const formattedData = formatReminders(response.data);
    return formattedData;
  } catch (err) {
    console.error("Error fetching pipelines:", err);
    throw err;
  }
};

export const postReminders = async (reminderData) => {
  try {
    const response = await api.post(
      `${BASE_URL}/admin/reminders`,
      reminderData,
      {
        headers: {
          Authorization: authorizationKey,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error posting reminder:", err);
    throw err;
  }
};

export const updateReminder = async ({ id, updatedData }) => {
  try {
    const response = await api.put(
      `${BASE_URL}/admin/reminders/${id}`,
      updatedData,
      {
        headers: {
          Authorization: authorizationKey,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error(`Error updating reminder with ID ${id}:`, err);
    throw err;
  }
};

export const deleteReminder = async (id) => {
  try {
    const response = await api.delete(`${BASE_URL}/admin/reminders/${id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error(`Error deleting reminder with ID ${id}:`, err);
    throw err;
  }
};
